/**
 * Формирует FormData из объекта
 * @param {Object} obj
 * @returns {FormData}
 */
export default function objectToFormData(obj = {}, formData = null, parentKey = null) {
    formData = formData || new FormData();

    Object.entries(obj).forEach(([key, value]) => {
        const propName = parentKey ? `${parentKey}[${key}]` : key;

        if (value === null || value === undefined) {
            return;
        }

        if (value instanceof Date) {
            formData.append(propName, value.toISOString());
        } else if (typeof value === 'object' && value !== null && !(value instanceof File) && !(value instanceof Blob)) {
            // Рекурсивно обрабатываем вложенные объекты
            objectToFormData(value, formData, propName);
        } else if (Array.isArray(value)) {
            // Обработка массивов
            value.forEach((item, index) => {
                const arrayKey = `${propName}[${index}]`;
                if (typeof item === 'object' && item !== null && !(item instanceof File) && !(item instanceof Blob)) {
                    objectToFormData(item, formData, arrayKey);
                } else {
                    formData.append(arrayKey, item);
                }
            });
        } else {
            // Простые значения (строки, числа, булевы)
            formData.append(propName, typeof value === 'boolean' ? Number(value) : value);
        }
    });

    return formData;
}